// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { GitBranch as RawGitBranch } from "lucide-react";
export const GitBranch = /* @__PURE__ */ createIcon(RawGitBranch, "GitBranch", 2);
